var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-switch",attrs:{"type":"button","role":"switch","aria-checked":_vm.checked,"aria-label":_vm.label || 'تغییر وضعیت',"disabled":_vm.disabled},on:{"click":_vm.toggleSwitch}},[_c('span',{staticClass:"switch-track",class:{ active: _vm.checked }},[_c('span',{staticClass:"switch-thumb",class:{ active: _vm.checked }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }